// Generated by npm run generate:owl-price-anchor-colors. Do not edit manually.
// Sources: data/cleartype-rgb/validation/021.png, data/cleartype-bgr/validation/021.png
export const OWL_PRICE_ANCHOR_RGBS = [
    [0, 119, 255],
    [0, 187, 204],
    [102, 153, 0],
    [221, 34, 204],
    [238, 0, 17],
    [255, 85, 0],
];
//# sourceMappingURL=owl_price_anchor_colors.js.map